import React from 'react'
import Icon from '@ant-design/icons'

const IpcSvg = () => (
  <svg viewBox="0 0 1024 1024" focusable="false" data-icon="pay-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 768a384 384 0 1 1 384-384 384 384 0 0 1-384 384z m0-704a320 320 0 1 0 320 320A320 320 0 0 0 512 64z" p-id="2116"></path><path d="M512 576a192 192 0 1 1 192-192 192 192 0 0 1-192 192z m0-320a128 128 0 1 0 128 128 128 128 0 0 0-128-128z" p-id="2117"></path><path d="M512 384h-64a64 64 0 0 1 64-64zM879.36 1024H144.64l81.6-203.84 59.52 23.68L239.36 960h545.28l-46.4-116.16 59.52-23.68L879.36 1024z" p-id="2118"></path></svg>
)

const IpcIcon = props => <Icon component={IpcSvg} {...props} />

export { IpcIcon }
